import { defineMessages } from 'react-intl'

const scope = `procurify.components.Budgets.BudgetCategoryCard`

export default defineMessages({
  currentSpendLabel: {
    id: `${scope}.currentSpendLabel`,
    defaultMessage: 'Current spend',
  },
  currentRequestLabel: {
    id: `${scope}.currentRequestLabel`,
    defaultMessage: 'Current request',
  },
  thisRequestLabel: {
    id: `${scope}.thisRequestLabel`,
    defaultMessage: 'This request',
  },
  otherPendingRequestsLabel: {
    id: `${scope}.otherPendingRequestsLabel`,
    defaultMessage: 'Other pending requests',
  },
  spendAfterApprovalLabel: {
    id: `${scope}.spendAfterApprovalLabel`,
    defaultMessage: 'Spend after approval',
  },
  budgetLabel: {
    id: `${scope}.budgetLabel`,
    defaultMessage: 'Budget',
  },
  timeZoneTooltip: {
    id: `${scope}.timeZoneTooltip`,
    defaultMessage:
      "Dates are displayed in the Headquarter's time zone: {timeZone}",
  },
  dateRangeTooltipIconAriaLabel: {
    id: `${scope}.dateRangeTooltipIconAriaLabel`,
    defaultMessage: 'Question icon',
  },
  noCurrentDateRange: {
    id: `${scope}.noCurrentDateRange`,
    defaultMessage: 'There is no current date range set for this budget.',
  },
  oldNoCurrentDateRange: {
    id: `${scope}.oldNoCurrentDateRange`,
    defaultMessage: 'There is no current date range set for this category.',
  },
  editCategory: {
    id: `${scope}.editCategory`,
    defaultMessage: 'Edit category',
  },
  editBudget: {
    id: `${scope}.editBudget`,
    defaultMessage: 'Edit budget',
  },
  varianceLabel: {
    id: `${scope}.varianceLabel`,
    defaultMessage: 'Variance',
  },
  attributesPopoverLabel: {
    id: `${scope}.attributesPopoverLabel`,
    defaultMessage: 'Budget Attributes',
  },
  oldAttributesPopoverLabel: {
    id: `${scope}.oldAttributesPopoverLabel`,
    defaultMessage: 'Budget Category Attributes',
  },
  secondaryOrgCategoryLabel: {
    id: `${scope}.secondaryOrgCategoryLabel`,
    defaultMessage: '{singularSecondaryOrgCategoryLabel}',
  },
  accountCodesLabel: {
    id: `${scope}.accountCodesLabel`,
    defaultMessage: 'Account Code',
  },
  subtotalsIsOverBudget: {
    id: `${scope}.subtotalsIsOverBudget`,
    defaultMessage: 'Over budget',
  },
  subtotalsIsOverBudgetExtraText: {
    id: `${scope}.subtotalsIsOverBudgetExtraText`,
    defaultMessage: '{overage} over',
  },
  subtotalsTotalLabel: {
    id: `${scope}.subtotalsTotalLabel`,
    defaultMessage: 'Total budget',
  },
  subtotalsCommittedLabel: {
    id: `${scope}.subtotalsCommittedLabel`,
    defaultMessage: 'Committed',
  },
  subtotalsCommittedTooltipLine1: {
    id: `${scope}.subtotalsCommittedTooltipLine1`,
    defaultMessage:
      '"Committed" refers to money that has already been allocated or set aside for a purchase.',
  },
  subtotalsCommittedTooltipLine2: {
    id: `${scope}.subtotalsCommittedTooltipLine2`,
    defaultMessage:
      'This includes amounts that have been approved (pending purchase), purchased, received, or billed.',
  },
  subtotalsApprovedLabel: {
    id: `${scope}.subtotalsApprovedLabel`,
    defaultMessage: 'Approved',
  },
  subtotalsPurchasedLabel: {
    id: `${scope}.subtotalsPurchasedLabel`,
    defaultMessage: 'Purchased',
  },
  subtotalsReceivedLabel: {
    id: `${scope}.subtotalsReceivedLabel`,
    defaultMessage: 'Received',
  },
  subtotalsBilledLabel: {
    id: `${scope}.subtotalsBilledLabel`,
    defaultMessage: 'Billed',
  },
  subtotalsPendingLabel: {
    id: `${scope}.subtotalsPendingLabel`,
    defaultMessage: 'Pending requests',
  },
  subtotalsRemainingLabel: {
    id: `${scope}.subtotalsRemainingLabel`,
    defaultMessage: 'Remaining',
  },
  subtotalsRemainingAfterRequestsLabel: {
    id: `${scope}.subtotalsRemainingAfterRequestsLabel`,
    defaultMessage: 'Remaining after pending requests',
  },
  subtotalsTotalAfterRequestsLabel: {
    id: `${scope}.subtotalsTotalAfterRequestsLabel`,
    defaultMessage: 'Total after pending requests',
  },
  subtotalsProgressBarTooltip: {
    id: `${scope}.subtotalsProgressBarTooltip`,
    defaultMessage:
      'Including pending requests, total spending will reach {total} ({percentage} of the budget).',
  },
})
